import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = {
    url: String,
    delay: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  search() {
    clearTimeout(this.timeout)

    const query = this.inputTarget.value.trim()

    // Debounce the search
    this.timeout = setTimeout(() => {
      this.performSearch(query)
    }, this.delayValue)
  }

  async performSearch(query) {
    // Build URL with query params
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set('search', query)

    // Add any active filters from the page
    const activeFilters = this.getActiveFilters()
    Object.keys(activeFilters).forEach(key => {
      url.searchParams.set(key, activeFilters[key])
    })

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      }
    } catch (error) {
      console.error('Search failed:', error)
    }
  }

  getActiveFilters() {
    const filters = {}

    // Get filters from URL params
    const params = new URLSearchParams(window.location.search)

    // Check for quick filter chips (has_open, has_rare, has_notes)
    if (params.get('has_open')) filters.has_open = params.get('has_open')
    if (params.get('has_rare')) filters.has_rare = params.get('has_rare')
    if (params.get('has_notes')) filters.has_notes = params.get('has_notes')

    // Check for advanced filters
    if (params.get('style')) filters.style = params.get('style')
    if (params.get('distillery_id')) filters.distillery_id = params.get('distillery_id')

    return filters
  }

  clear() {
    this.inputTarget.value = ''
    this.search()
  }
}
